module.exports = __webpack_public_path__ + "static/img/Xinli.297518fd.png";